export default __webpack_public_path__ + "static/media/herobg.5ad95841.jpg";